import Cropper from "react-easy-crop";

import type { Area, Point } from "../Cropper";
import { CropSlider } from "../CropSlider";
import { ImageError } from "./ImageError";

export interface ImageCropperProps {
  aspectRatio?: number;
  crop: Point;
  file?: string;
  imageError?: string;
  onCropComplete: (croppedArea: Area, croppedAreaPixels: Area) => void;
  setCrop: (crop: Point) => void;
  setZoom: (zoom: number) => void;
  zoom: number;
}

export const ImageCropper = ({
  imageError,
  file,
  crop,
  aspectRatio,
  zoom,
  setCrop,
  setZoom,
  onCropComplete,
}: ImageCropperProps) => (
  <div className="flex flex-col gap-4">
    <ImageError error={imageError} />
    <div className="relative h-80 w-full overflow-hidden rounded-lg">
      <Cropper
        image={file}
        crop={crop}
        aspect={aspectRatio}
        zoom={zoom}
        onCropChange={setCrop}
        onZoomChange={setZoom}
        onCropComplete={onCropComplete}
      />
    </div>
    <CropSlider
      value={zoom}
      onChange={zoom => {
        if (Array.isArray(zoom) && typeof zoom[0] === "number") {
          setZoom(zoom[0]);
          return;
        }

        if (typeof zoom === "number") {
          setZoom(zoom);
        }
      }}
    />
  </div>
);
